import React from "react";
import "./PlaceholderThumb.css";
import { string } from "prop-types";


const PlaceholderThumb = ({ firstName, lastName, contactDefaultPhoto, size }) => {
  
  return (
    <div className={"placeholder-thumb"} style={{ fontSize: size, background: contactDefaultPhoto}}>
      <span>
        {firstName.charAt(0)} {lastName.charAt(0)}
      </span>
    </div>
  );
};

PlaceholderThumb.propTypes = {
  firstName: string,
  lastName: string
};

export default PlaceholderThumb;



// WEBPACK FOOTER //
// ./src/common/thumb/PlaceholderThumb.js